import { Dispatch, SetStateAction } from 'react';
import { Modal } from 'flowbite-react';
import FailureBreakDownBarChart from './FailureBreakDownBarChart';
import { BookingFailureLogsStatistics, Breakdown7DaysItem } from 'src/types/bookingFailureLog.type';
import { ReactComponent as CloseIcon } from 'assets/image/svg/ic-close.svg';
import { useTranslation } from 'react-i18next';

type DropdownProps = {
   openModal: boolean;
   setOpenModal: Dispatch<SetStateAction<boolean>>;
   bookingFailureStats: BookingFailureLogsStatistics;
   breakdown7Days: Breakdown7DaysItem[];
};

const ScorecardModal = ({ openModal, setOpenModal, bookingFailureStats, breakdown7Days }: DropdownProps) => {
   const { t } = useTranslation();
   return (
      <Modal show={openModal} dismissible onClose={() => setOpenModal(false)} size="md" aria-label={t('a11y.dialog.overviewScorecards')} theme={{ root: { sizes: { md: 'max-w-fit' } } }}>
         <CloseIcon className="text-orgPrimary absolute right-5 top-5 z-1 cursor-pointer" onClick={() => setOpenModal(false)} />

         <div className="p-3.75 font-bold text-xl cursor-pointer text-center" onClick={() => setOpenModal(true)}>
            Overview Scorecards
         </div>

         <div className="flex flex-wrap gap-3.75 px-7.5 py-3.75 max-w-[668px]">
            <div className="min-w-40 h-auto p-3.75 rounded-10 border border-border bg-lightGray shadow-[1px_1px_2px_0px_#00000033]">
               <h2 className="text-xl font-bold">Failures (24h)</h2>
               <p className="text-[44px] font-bold text-red-600">{bookingFailureStats?.failure24h}</p>
               <span className="text-green-600 text-base font-semibold">
                  {bookingFailureStats?.failureDiff24h}% <strong className="text-black font-semibold">vs yesterday</strong>
               </span>
            </div>

            <div className="flex-1 min-w-[296px] h-auto p-3.75 rounded-10 border border-border bg-lightGray shadow-[1px_1px_2px_0px_#00000033]">
               <h2 className="text-xl font-bold">Failure Rate (24h)</h2>
               <p className="text-[44px] font-bold text-red-600">{bookingFailureStats?.failureRate24h}%</p>
               <span className="text-red-600 text-base font-semibold">{bookingFailureStats?.failureDiffRate24h}%</span>
            </div>

            <div className="flex-1 min-w-[357px] h-auto p-3.75 rounded-10 border border-border bg-lightGray shadow-[1px_1px_2px_0px_#00000033]">
               <h2 className="text-xl font-bold mb-3.75">Failure Breakdown (Last 7 Days)</h2>
               {breakdown7Days && breakdown7Days.length ? <FailureBreakDownBarChart breakdown7Days={breakdown7Days} /> : null}
            </div>

            <div className="flex-1 min-w-[236px] h-auto p-3.75 rounded-10 border border-border bg-lightGray shadow-[1px_1px_2px_0px_#00000033]">
               <h2 className="text-lg font-semibold">Top Error Type</h2>
               <p className="text-red-600 text-xl font-bold mt-3.75">{bookingFailureStats?.topErrorType?.type}</p>
               <p className="text-black text-base font-semibold">{bookingFailureStats?.topErrorType?.occurrences} occurrences</p>
            </div>
         </div>
      </Modal>
   );
};
export default ScorecardModal;
